import React, { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useRatings } from './RatingsContext';

function OverallIndividualScore() {
  const { kpaRatings, standardsRatings } = useRatings();
  const ratingOptions = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];
  const [moderatorRating, setModeratorRating] = useState(null);
  const [moderatorComments, setModeratorComments] = useState('');
  const [showModal, setShowModal] = useState(false);

  // Calculate overall self rating
  const calculateOverallSelfRating = () => {
    const kpaSelfRating = kpaRatings?.selfRatingData?.rating;
    const standardsSelfRating = standardsRatings?.selfRatingData?.rating;
    const validRatings = [kpaSelfRating, standardsSelfRating].filter(rating => rating !== null && rating !== undefined);
    if (validRatings.length === 0) return { rating: null, percentage: null };
    const averageRating = validRatings.reduce((sum, rating) => sum + rating, 0) / validRatings.length;
    return {
      rating: parseFloat(averageRating.toFixed(1)),
      percentage: parseFloat(((averageRating / 5) * 100).toFixed(0)),
    };
  };

  // Calculate overall line manager rating
  const calculateOverallLineManagerRating = () => {
    const kpaLineManagerRating = kpaRatings?.lineManagerRatingData?.rating;
    const standardsLineManagerRating = standardsRatings?.lineManagerRatingData?.rating;
    const validRatings = [kpaLineManagerRating, standardsLineManagerRating].filter(rating => rating !== null && rating !== undefined);
    if (validRatings.length === 0) return { rating: null, percentage: null };
    const averageRating = validRatings.reduce((sum, rating) => sum + rating, 0) / validRatings.length;
    return {
      rating: parseFloat(averageRating.toFixed(1)),
      percentage: parseFloat(((averageRating / 5) * 100).toFixed(0)),
    };
  };

  // Final/Moderator rating
  const finalModeratorRatingData = {
    rating: moderatorRating,
    percentage: moderatorRating ? parseFloat(((moderatorRating / 5) * 100).toFixed(0)) : null,
  };

  const overallSelfRatingData = calculateOverallSelfRating();
  const overallLineManagerRatingData = calculateOverallLineManagerRating();

  const handleSaveModerator = () => {
    console.log('handleSaveModerator called with rating:', moderatorRating, 'comments:', moderatorComments);
    setShowModal(false);
  };

  const renderStars = (rating) => {
    if (rating === null) return 'Not Rated';
    return [...Array(5)].map((_, i) => (
      <i key={i} className={`bi ${i < rating ? 'bi-star-fill' : 'bi-star'} text-warning me-1`} />
    ));
  };

  return (
    <div className="container mt-4">
      <div className="d-flex align-items-center mb-3 bg-tertiary p-2 text-light rounded">
        <h4 className="mb-0">Overall Individual Score</h4>
        <button type="button" className="btn btn-primary ms-auto" onClick={() => setShowModal(true)}>
          Moderator Rating
        </button>
      </div>
      <div className="row g-3">
        <div className="col-lg-3 col-md-6">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title">Self Rating</h5>
              <div className="d-flex align-items-center mb-2">
                <div className="me-3">{renderStars(overallSelfRatingData.rating)}</div>
                <span>{overallSelfRatingData.rating !== null ? `${overallSelfRatingData.rating}/5` : 'Not Rated'}</span>
</div>
<div className="progress" style={{ height: '20px' }}>
    <div
        className="progress-bar"
        role="progressbar"
        style={{ width: overallSelfRatingData.percentage ? `${overallSelfRatingData.percentage}%` : '0%' }}
        aria-valuenow={overallSelfRatingData.percentage || 0}
        aria-valuemin="0"
        aria-valuemax="100"
    >
        {overallSelfRatingData.percentage !== null ? `${overallSelfRatingData.percentage}%` : 'Not Rated'}
    </div>
</div>
</div>
</div>
</div>
<div className="col-lg-3 col-md-6">
    <div className="card h-100">
        <div className="card-body">
            <h5 className="card-title">Line Manager Rating</h5>
            <div className="d-flex align-items-center mb-2">
                <div className="me-3">{renderStars(overallLineManagerRatingData.rating)}</div>
                <span>{overallLineManagerRatingData.rating !== null ? `${overallLineManagerRatingData.rating}/5` : 'Not Rated'}</span>
            </div>
            <div className="progress" style={{ height: '20px' }}>
                <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: overallLineManagerRatingData.percentage ? `${overallLineManagerRatingData.percentage}%` : '0%' }}
                    aria-valuenow={overallLineManagerRatingData.percentage || 0}
                    aria-valuemin="0"
                    aria-valuemax="100"
                >
                    {overallLineManagerRatingData.percentage !== null ? `${overallLineManagerRatingData.percentage}%` : 'Not Rated'}
                </div>
            </div>
        </div>
    </div>
</div>
<div className="col-lg-3 col-md-6">
    <div className="card h-100">
        <div className="card-body">
            <h5 className="card-title">Final/Moderator</h5>
            <div className="d-flex align-items-center mb-2">
                <div className="me-3">{renderStars(finalModeratorRatingData.rating)}</div>
                <span>{finalModeratorRatingData.rating !== null ? `${finalModeratorRatingData.rating}/5` : 'Not Rated'}</span>
            </div>
            <div className="progress" style={{ height: '20px' }}>
                <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: finalModeratorRatingData.percentage ? `${finalModeratorRatingData.percentage}%` : '0%' }}
                    aria-valuenow={finalModeratorRatingData.percentage || 0}
                    aria-valuemin="0"
                    aria-valuemax="100"
                >
                    {finalModeratorRatingData.percentage !== null ? `${finalModeratorRatingData.percentage}%` : 'Not Rated'}
                </div>
            </div>
        </div>
    </div>
</div>
<div className="col-lg-3 col-md-6">
    <div className="card h-100">
        <div className="card-body">
            <h5 className="card-title">Moderator Comments</h5>
            <textarea
                className="form-control"
                value={moderatorComments}
                readOnly
                disabled
                rows={6}
            />
        </div>
    </div>
</div>
</div>

<div className={`modal fade ${showModal ? 'show d-block' : ''}`} style={{ backgroundColor: showModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
    <div className="modal-dialog">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title">Moderator Rating</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)} />
            </div>
            <div className="modal-body">
                <div className="mb-3">
                    <label htmlFor="moderatorRating" className="form-label">Moderator Rating</label>
                    <select
                        className="form-select"
                        id="moderatorRating"
                        value={moderatorRating || ''}
                        onChange={(e) => setModeratorRating(e.target.value ? parseFloat(e.target.value) : null)}
                    >
                        <option value="">Select Rating</option>
                        {ratingOptions.map((val) => (
                            <option key={val} value={val}>{val}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-3">
                    <label htmlFor="moderatorComments" className="form-label">Moderator Comments</label>
                    <textarea
                        className="form-control"
                        id="moderatorComments"
                        value={moderatorComments}
                        onChange={(e) => setModeratorComments(e.target.value)}
                        rows={4}
                    />
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleSaveModerator}>Save</button>
            </div>
        </div>
    </div>
</div>
</div>
);
}

export default OverallIndividualScore;